import { render, staticRenderFns } from "./miniprogramPopup.vue?vue&type=template&id=4f718aba&scoped=true"
import script from "./miniprogramPopup.vue?vue&type=script&lang=ts"
export * from "./miniprogramPopup.vue?vue&type=script&lang=ts"
import style0 from "./miniprogramPopup.vue?vue&type=style&index=0&id=4f718aba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f718aba",
  null
  
)

export default component.exports